import React from 'react';
import { FileText, GitBranch, Database, Presentation, FileCheck, BookMarked } from 'lucide-react';

const TYPES = [
  {
    icon: FileText,
    title: 'Published papers and preprints',
    body:
      'Sortio reads each paper for the title, authors, year, journal, DOI, and abstract, then renames to a clean Vaswani_2017_Attention-is-all-you-need.pdf pattern. The same paper as preprint and as camera-ready version are deduplicated, with the camera-ready treated as canonical and the preprint kept alongside.',
  },
  {
    icon: Database,
    title: 'Supplemental data and notebooks',
    body:
      'CSVs, parquet files, Jupyter notebook exports, raw experimental logs. Sortio routes these under the matching paper folder so the data lives next to the publication. Future-you (or a reviewer) can find the exact dataset that produced figure 3 without crawling four directories.',
  },
  {
    icon: GitBranch,
    title: 'Draft chapters and version control',
    body:
      'Word documents, LaTeX projects, Overleaf zips, Google Docs exports. Sortio tags each with the modification date, the chapter or section, and (when present) the reviewer name. thesis_v3_FINAL_REAL.docx becomes 2026-04-12 - Thesis Chapter 4 - after Advisor.docx and supersedes earlier versions in a clean history.',
  },
  {
    icon: Presentation,
    title: 'Slide decks and posters',
    body:
      'Conference talks, lab meeting slides, poster PDFs, AAAS presentations. Sortio recognizes presentation files and routes them under the matching project, tagged by venue and date. Pulling together slides for a recurring talk is a search instead of an excavation.',
  },
  {
    icon: FileCheck,
    title: 'Grant applications and IRB',
    body:
      'NSF proposals, NIH R01 applications, departmental seed grant forms, IRB protocols and amendments, conflict-of-interest disclosures. Sortio routes administrative research docs into a separate Grants and IRB folder per project, with year and submission deadline tagging.',
  },
  {
    icon: BookMarked,
    title: 'Citation and bibliography exports',
    body:
      'BibTeX exports, RIS files, EndNote dumps, Zotero CSL JSON. Sortio recognizes citation export formats and routes them alongside the corresponding paper. When the Zotero integration ships, these exports become a roundtrip: Sortio uploads the PDF, Zotero generates the citation key, and the BibTeX entry lands in your .bib file.',
  },
];

const DocumentTypes = () => {
  return (
    <section id="document-types" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Document types Sortio recognizes
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          The categories that show up in active research and how Sortio routes each one.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TYPES.map((type, i) => {
          const Icon = type.icon;
          return (
            <div key={i} className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6">
              <div className="w-10 h-10 rounded-full bg-sortio-primary/15 border border-sortio-primary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-primary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{type.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{type.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default DocumentTypes;
